import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import Logo from '../components/Logo';

export default function Activate() {
  const { token }   = useParams();
  const navigate    = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [done, setDone]         = useState(false);

  async function activate(e) {
    e.preventDefault();
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (password !== confirm)  { setError('Passwords do not match'); return; }
    setSaving(true);
    setError('');
    try {
      await api.post('/api/v1/auth/activate', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Activation failed. The link may have expired.');
      setSaving(false);
    }
  }

  if (done) return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ textAlign: 'center', padding: '12px 0' }}>
          <div style={{ fontSize: '44px', marginBottom: '16px', color: '#14b8a6' }}>✓</div>
          <h2 style={s.title}>Account activated!</h2>
          <p style={s.sub}>Your password has been set. You can now sign in to MouldOS.</p>
          <button style={s.btn} onClick={() => navigate('/')}>Go to sign in</button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={s.brand}><Logo size={18} /></div>
          <h2 style={s.title}>Activate your account</h2>
          <p style={s.sub}>Choose a password to complete your account setup.</p>
        </div>
        <form onSubmit={activate}>
          {error && <div style={s.error}>{error}</div>}
          <Field label="New password">
            <input
              style={s.input}
              type="password"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              placeholder="Min. 6 characters"
              autoFocus
              autoComplete="new-password"
            />
          </Field>
          <Field label="Confirm password">
            <input
              style={s.input}
              type="password"
              value={confirm}
              onChange={e => { setConfirm(e.target.value); setError(''); }}
              placeholder="Repeat password"
              autoComplete="new-password"
            />
          </Field>
          <button
            type="submit"
            style={{ ...s.btn, width: '100%', marginTop: '8px', opacity: saving ? 0.6 : 1 }}
            disabled={saving}>
            {saving ? 'Activating...' : 'Activate Account'}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#6b7280', marginBottom: '4px' }}>{label}</label>
      {children}
    </div>
  );
}

const s = {
  page:  { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f1117', fontFamily: 'system-ui, sans-serif', padding: '20px' },
  card:  { background: '#1e2329', border: '1px solid #2a3040', borderRadius: '16px', padding: '36px 32px', width: '100%', maxWidth: '380px' },
  brand: { display: 'flex', justifyContent: 'center', marginBottom: '16px' },
  title: { fontSize: '20px', fontWeight: '700', color: '#f0f2f5', margin: '0 0 8px 0' },
  sub:   { fontSize: '13px', color: '#6b7280', margin: 0, lineHeight: '1.5' },
  input: { background: '#0f1117', border: '1px solid #2a3040', borderRadius: '6px', color: '#f0f2f5', padding: '10px 12px', fontSize: '13px', fontFamily: 'system-ui, sans-serif', width: '100%', boxSizing: 'border-box' },
  btn:   { background: '#14b8a6', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px 24px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' },
  error: { background: '#7f1d1d', color: '#fca5a5', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', marginBottom: '14px' },
};
